import React from 'react';

const useShowPassword = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword2, setShowPassword2] = React.useState(false);
  return { showPassword, setShowPassword, showPassword2, setShowPassword2 };
};

export default useShowPassword;
